import { render, staticRenderFns } from "./repository_overflow_menu.vue.js?vue&type=template&id=59d29496&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./repository_overflow_menu.vue?vue&type=template&id=59d29496&vue3"
import script from "./repository_overflow_menu.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./repository_overflow_menu.vue?vue&type=script&lang=js&vue3"
export * from "./repository_overflow_menu.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./repository_overflow_menu.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports